// Filter.jsx
import React, { useState, useRef, useEffect } from 'react';
import { FaCaretDown, FaSearch } from 'react-icons/fa';
import './Filter.css'

const FilterUsers = ({ searchText, setSearchText }) => {

    return (
        <div className="search-bar">
            <input
                type="text"
                placeholder="Search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="table-search-input"
            />
            <FaSearch className="search-icon" />
        </div>
    );
};

export default FilterUsers;
